import { Box } from '@mui/material';
import { KeyboardEvent, ReactNode } from 'react';
import { isTouchEnabled } from '../../Theme';

const ACTIVATION_KEYS = ['Enter', ' '];

interface PriceCompositionMarkerProps {
  children: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}

const PriceCompositionMarker = ({
  children,
  isActive = true,
  onClick,
}: PriceCompositionMarkerProps) => {
  const isClickable = isActive && isTouchEnabled && !!onClick;

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!isClickable || !ACTIVATION_KEYS.includes(event.key)) {
      return;
    }

    event.preventDefault();
    onClick?.();
  };

  return (
    <Box
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={isClickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap: theme.spacing(3 / 4),
        cursor: isClickable ? 'pointer' : 'default',
        borderBottom: isActive ? `1px dotted ${theme.palette.text.disabled}` : 'none',
      })}
    >
      {children}
    </Box>
  );
};

export default PriceCompositionMarker;
